import Api from '../../../../foundation/api/Api';
import Registry from '../../../global/Registry';
import ExerciseTemplate from '../domain/aggregates/exerciseTemplate/ExerciseTemplate';

export default class ExerciseTemplateApi extends Api<ExerciseTemplate> {

	private static instance?: ExerciseTemplateApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().exerciseTemplateRepository);
	}

	public async getAll () {
		return await this.getList('/api/exercise-templates');
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/api/ExerciseTemplateApi.ts